import React, { useMemo } from 'react';
import ScenePlayer from './ScenePlayer';
import { getLanguage, t } from '../i18n';

const LEGACY_TRAINER_IDS = {
  male: 0,
  female: 1,
  board: 2,
};

function normalizeLegacyMessage(message, language) {
  const comment = typeof message?.comment === 'string' && message.comment.trim()
    ? message.comment.trim()
    : t('practiceUi.coaching.message', language);
  const legacyTrainer = typeof message?.trainer === 'string'
    ? LEGACY_TRAINER_IDS[message.trainer.trim().toLowerCase()]
    : undefined;
  const trainerId = Number.isInteger(message?.trainer_Id) && message.trainer_Id >= 0
    ? message.trainer_Id
    : legacyTrainer ?? 0;
  const index = Number.isInteger(message?.index) && message.index >= 0
    ? message.index
    : 0;

  return {
    name: t('practiceUi.coaching.title', language),
    text: comment,
    image: `practice_${index}_${trainerId}`,
    alt: t('practiceUi.coaching.trainer', language, { trainer: trainerId, practice: index + 1 }),
  };
}

function CoachingTimeOverlay({ message, onContinue }) {
  const scene = message?.frames ? message : message?.scene;
  const language = getLanguage();
  const fallbackFrame = useMemo(() => normalizeLegacyMessage(message, language), [message, language]);

  return (
    <ScenePlayer
      scene={scene}
      fallbackFrame={fallbackFrame}
      onContinue={onContinue}
      variant="coaching"
      continueLabel={t('dashboard.startWorkout')}
      nextLabel={t('common.next')}
      messageTestId="coaching-time-message"
    />
  );
}

export default CoachingTimeOverlay;
